/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ActivityType/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Comment from './Comment/index'
import Creation from './Creation/index'
import Log from './Log/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ActivityType({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content/Content/Activities/Content/Activity/ActivityType"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let activityTypeValueData = fromData.useDataFormat({ viewPath,
context: 'activity',
path: 'type',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: activityTypeValueData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Comment'}>
<Comment
  viewPath={`${viewPath}/Comment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Creation'}>
<Creation
  viewPath={`${viewPath}/Creation`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Log'}>
<Log
  viewPath={`${viewPath}/Log`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}